module.exports = __webpack_public_path__ + "media/goforajourney/img/marrakech-card-b32d4889e25b0bd28e4121108f061afc.webp";